module.exports = __webpack_public_path__ + "img/credit_1.7173985b.jpg";